import React from 'react';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { IconMutedButton, ButtonProps } from '@app/core';

const useStyles = createUseStyles(() => ({
  button: {
    width: '100%',
    flex: 1,
  },
}));

interface Props {
  text?: string;
  buttonClassName?: string;
}

export const AddButton = ({
  buttonClassName,
  ...props
}: ButtonProps & Props) => {
  const classes = useStyles();
  return (
    <IconMutedButton
      icon="ri-add-circle-line"
      iconColor="green"
      className={classnames(classes.button, buttonClassName)}
      {...props}
    />
  );
};
